customElements.whenDefined('media-gallery').then(() => {
  document.querySelectorAll('media-gallery[data-tv-size-gallery]').forEach((gallery) => {
    gallery.addEventListener('click', (event) => {
      const button = event.target.closest('.thumbnail');
      const thumbnail = button?.closest('[data-target]');
      if (!thumbnail || !gallery.contains(thumbnail)) return;
      event.preventDefault();
      event.stopPropagation();
      gallery.setActiveMedia(thumbnail.dataset.target, false);
    }, true);
    const viewer = gallery.querySelector('.product__media-list');
    let restoreFrame;
    const restoreActiveImage = () => {
      cancelAnimationFrame(restoreFrame);
      restoreFrame = requestAnimationFrame(() => {
        const active = viewer.querySelector('.is-active');
        if (active) viewer.scrollTo({ left: active.offsetLeft, behavior: 'instant' });
      });
    };
    window.addEventListener('resize', restoreActiveImage);
    const modal = document.querySelector('#ProductModal-' + gallery.id.replace('MediaGallery-', ''));
    if (modal) {
      const modalObserver = new MutationObserver(() => {
        if (!modal.hasAttribute('open')) restoreActiveImage();
      });
      modalObserver.observe(modal, { attributes: true, attributeFilter: ['open'] });
    }
    if (!gallery.dataset.initialSize) return;
    const slide = Array.from(gallery.querySelectorAll('[data-tv-size]')).find(
      (item) => item.dataset.tvSize === gallery.dataset.initialSize
    );
    if (slide) gallery.setActiveMedia(slide.dataset.mediaId, false);
  });
});
